import { render, staticRenderFns } from "./table-chengpin.vue?vue&type=template&id=55b5f3c2&scoped=true"
import script from "./table-chengpin.vue?vue&type=script&lang=js"
export * from "./table-chengpin.vue?vue&type=script&lang=js"
import style0 from "./table-chengpin.vue?vue&type=style&index=0&id=55b5f3c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b5f3c2",
  null
  
)

export default component.exports